import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import { convertItemsToTilesChannelCategory, chunkArray } from "../formatters/ItemFormatter";
import { dnsResolver } from "./dnsResolver"; // Import your DNS resolver

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();

export default function (filter: string) {
  return async (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    //@ts-ignore
    const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default"; // Optional unique identifier for the API instance

    const cacheKey = `${apiIdentifier}_${username}_series_categories`;
    const tileKey = `${filter}_${apiIdentifier}_${username}_series_categories`;

    let originalUrl = `/player_api.php?username=${username}&password=${password}&action=get_series_categories`;
    let finalUrl = originalUrl;
    let hostHeader = null;

    // Check cache first
    if (cache.has(cacheKey)) {
      console.log(`💾 Using cached data for series categories`);
      return cache.get(cacheKey);
    }

    // CUSTOM DNS TRANSFORMATION
    try {
      // Get the base URL from your API instance
      const baseUrl = api.baseURL || api.defaults?.baseURL || window.location.origin;
      const fullUrl = `${baseUrl}${originalUrl}`;

      console.log(`🌐 Starting DNS transformation for series categories: ${fullUrl}`);
      console.log(`🔧 DNS Info:`, dnsResolver.getDnsInfo());

      // Apply custom DNS if enabled
      const dnsResult = await dnsResolver.transformUrl(fullUrl);
      console.log(`📡 DNS transformation result for series categories:`, dnsResult);

      if (typeof dnsResult === "object" && dnsResult.url) {
        // Custom DNS successfully transformed the URL
        finalUrl = dnsResult.url.replace(baseUrl, ""); // Get relative path
        hostHeader = dnsResult.originalHost;
        console.log(`✅ Custom DNS applied to series categories:`);
        console.log(`   Original: ${fullUrl}`);
        console.log(`   Transformed: ${dnsResult.url}`);
        console.log(`   Host header: ${hostHeader}`);
      } else if (typeof dnsResult === "string") {
        // URL returned as string (might be unchanged)
        if (dnsResult !== fullUrl) {
          finalUrl = dnsResult.replace(baseUrl, "");
          console.log(`🔄 Series categories URL modified: ${dnsResult}`);
        } else {
          console.log(`📝 Series categories URL unchanged (localhost or DNS disabled)`);
        }
      }
    } catch (dnsError) {
      console.warn("❌ DNS transformation failed for series categories:", dnsError);
      finalUrl = originalUrl; // Use original URL
    }

    console.log(`📞 Making series categories API call with URL: ${finalUrl}`);

    // Make the API call
    const result = api
      ._get(finalUrl, {
        // Add Host header if we have one (for custom DNS)
        ...(hostHeader && { headers: { Host: hostHeader } }),
      })
      .then(channels => {
        console.log(`Series categories API call successful, processing ${channels?.length || 0} categories`);

        // Validate response is an array
        if (!Array.isArray(channels)) {
          console.warn(`Series categories response is not an array:`, typeof channels);
          return [];
        }

        const results = channels;
        const existingTiles = leftoverTiles.get(tileKey) || [];
        const tiles = existingTiles.concat(convertItemsToTilesChannelCategory(results));

        const chunks = chunkArray(tiles);
        if (chunks[chunks.length - 1]?.length < 7) {
          leftoverTiles.set(tileKey, chunks.pop() || []);
        } else {
          leftoverTiles.delete(tileKey);
        }

        console.log(`Series categories processed: ${tiles.length} total tiles created`);
        return tiles;
      })
      .catch(error => {
        console.error(`Series categories API call failed:`, error.message);
        cache.delete(cacheKey);
        return []; // Return empty array instead of crashing
      });

    cache.set(cacheKey, result);
    return result;
  };
}
